/**
 * MuiIconButton
 */
const MuiIconButton = {
  styleOverrides: {
    sizeSmall: {
      '& > svg': {
        fontSize: 16
      }
    }
  }
};
export default MuiIconButton;